import React from "react"
import { Translate } from "utils/i18n-shim"

import { EmptyState } from "shared/ui/berry-jass-extended"

export const TableEmptyState = ({ sx = {} }) => {
  return (
    <EmptyState
      text={<Translate value="billing-addresses.table.no-data-text" />}
      subText={<Translate value="billing-addresses.table.no-data-sub-text" />}
      sx={{ border: "none", ...sx }}
    />
  )
}
